module.exports = __webpack_public_path__ + "img/loudongliyong.0784e045.png";